import React, { PropsWithChildren } from "react";
import { getServerSession } from "next-auth";
import { AuthProvider, createAuthOptions } from "@workspace/auth";
import { StoreProvider } from "./store.provider";

const authOptions = createAuthOptions();

export const CoreProvider = async ({ children }: PropsWithChildren) => {
  const session = await getServerSession(authOptions);

  return (
    <AuthProvider session={session}>
      <StoreProvider>{children}</StoreProvider>
    </AuthProvider>
  );
};
